export const GUIDE_TABS = [
  { id: 'reach', label: 'How to Reach', icon: 'plane' },
  { id: 'stay', label: 'Where to Stay', icon: 'bed-double' },
  { id: 'transport', label: 'Local Transport', icon: 'car' },
  { id: 'when', label: 'Best Time to Visit', icon: 'sunrise' },
  { id: 'tips', label: 'Travel Tips', icon: 'info' },
  { id: 'itineraries', label: 'Itineraries', icon: 'route' },
];

const DAY1 = ['Ram Mandir darshan (morning slot)', 'Hanuman Garhi', 'Kanak Bhawan', 'Lunch near Hanuman Garhi', 'Nageshwarnath Temple', 'Saryu aarti at Ram ki Paidi'];
const DAY2 = ['Guptar Ghat at sunrise', 'Treta ke Thakur', 'Sita ki Rasoi', 'Dashrath Mahal', 'Boat ride on the Saryu', 'Evening bhajan at Ram Katha Park'];
const DAY3 = ['Mani Parbat', 'Gulab Bari', 'Bahu Begum ka Maqbara', 'Ram ki Paidi walk', 'Shopping at Ram Path', 'Deep daan on the Saryu'];

export const GUIDE = {
  reach: {
    title: 'How to Reach Ayodhya',
    intro: 'Ayodhya is well connected by air, rail and road to every major city in North India.',
    items: [
      { icon: 'plane', title: 'By Air', body: 'Maharishi Valmiki International Airport (AYJ) is 10 km from the city, with daily flights from Delhi, Mumbai, Bengaluru, Ahmedabad and Kolkata. Taxis and e-rickshaws wait outside arrivals.' },
      { icon: 'train-front', title: 'By Train', body: 'Ayodhya Dham Junction (AY) sits 1.5 km from Ram Mandir; Ayodhya Cantt (FD) is 7 km away. Direct trains run from Lucknow, Varanasi, Delhi, Kolkata and Mumbai.' },
      { icon: 'car', title: 'By Road', body: 'NH27 and NH330 connect the city. Lucknow 135 km (3 h), Gorakhpur 140 km (3.5 h), Varanasi 200 km (4.5 h), Prayagraj 165 km (4 h). UPSRTC buses arrive at the new bus stand on Ram Path.' },
    ],
  },
  stay: {
    title: 'Where to Stay',
    intro: 'From Trust-run dharamshalas to heritage hotels, choose a base that suits your budget and pace.',
    items: [
      { icon: 'temple', title: 'Near Ram Mandir', body: 'Walk to darshan and the evening aarti. Best for early Mangla aarti slots. Books out during festivals.', to: '/hotels', cta: 'See stays' },
      { icon: 'home', title: 'Dharamshalas & Trust Guesthouses', body: 'Clean, affordable and welcoming to families. Many include a simple sattvic meal.', to: '/hotels?category=dharamshala', cta: 'Budget stays' },
      { icon: 'building-2', title: 'Civil Lines & Ram Path', body: 'Mid-range and premium hotels with restaurants, parking and easy access to the highway.', to: '/hotels?category=premium', cta: 'Premium stays' },
      { icon: 'bed-double', title: 'Faizabad (Ayodhya Cantt)', body: 'Larger hotel inventory 7 km away — a smart choice when the old city is full.', to: '/hotels', cta: 'All hotels' },
    ],
  },
  transport: {
    title: 'Getting Around',
    intro: 'The old city is compact. Most temples are within a 2 km radius of Hanuman Garhi.',
    items: [
      { icon: 'car', title: 'E-rickshaw & Auto', body: '₹20–₹50 for short hops inside the city. Agree on the fare before you sit.' },
      { icon: 'bus', title: 'Ayodhya Darshan Bus', body: 'Hop-on hop-off electric buses loop the main temples and ghats through the day.' },
      { icon: 'navigation', title: 'Taxi & Cab', body: 'Pre-book for airport transfers and day trips to Guptar Ghat or Bharat Kund.' },
      { icon: 'route', title: 'On Foot — Parikrama', body: 'The Panchkosi and Chaudah Kosi parikrama routes pass most shrines; wear comfortable footwear.' },
    ],
  },
  when: {
    title: 'Best Time to Visit',
    intro: 'Ayodhya welcomes pilgrims year-round; the cool months are the most comfortable.',
    seasons: [
      { label: 'October – March', body: 'Pleasant 8–25°C. Deepotsav (Oct/Nov), Kartik Purnima and Ram Navami (Mar/Apr) bring the city alive.', best: true, icon: 'sunrise' },
      { label: 'April – June', body: 'Hot, 35–45°C. Plan early-morning darshan and rest in the afternoon.', icon: 'sun' },
      { label: 'July – September', body: 'Monsoon greens the ghats; the Sawan Jhula Mela in August is a joyful spectacle.', icon: 'waves' },
    ],
  },
  tips: {
    title: 'Travel Tips',
    intro: 'Small preparations make the pilgrimage smoother.',
    items: [
      'Dress modestly — shoulders and knees covered inside temples.',
      'No phones, cameras, bags or leather items inside the Ram Mandir sanctum; use the free lockers.',
      'Carry a government photo ID for darshan passes and hotel check-in.',
      'Keep small cash for e-rickshaws, prasad and footwear counters.',
      'Reach Ram ki Paidi 45 minutes before sunset for a good aarti spot.',
      'Book Ram Mandir passes only on the official Trust portal — they are free.',
      'Hydrate and carry a cap in summer; a shawl in winter mornings.',
      'Respect queue rules and volunteers; senior citizens get separate lines.',
    ],
  },
  itineraries: {
    title: 'Suggested Itineraries',
    intro: 'Curated plans you can follow as-is or customise in the Trip Planner.',
    items: [
      { days: 1, title: 'One-day Darshan', stops: DAY1 },
      { days: 2, title: 'Two-day Pilgrimage', stops: [...DAY1.slice(0, 3), 'Saryu aarti at Ram ki Paidi', ...DAY2] },
      { days: 3, title: 'Three-day Immersion', stops: [...DAY1.slice(0, 3), 'Saryu aarti at Ram ki Paidi', ...DAY2, ...DAY3] },
    ],
  },
};

export const DID_YOU_KNOW = [
  'Ayodhya is one of the seven Moksha-puris — cities believed to grant liberation.',
  'The Saryu is mentioned in the Rigveda, making it among the oldest named rivers in India.',
  'Deepotsav 2024 lit over 25 lakh diyas on the ghats — a Guinness World Record.',
];
